import { render } from "./PickColor.vue?vue&type=template&id=46d9310e&scoped=true"
import script from "./PickColor.vue?vue&type=script&lang=js"
export * from "./PickColor.vue?vue&type=script&lang=js"

import "./PickColor.vue?vue&type=style&index=0&id=46d9310e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d9310e"]])

export default __exports__